export const SIDEBAR = {};
SIDEBAR.SET_SIDEBAR_ACTIVE_NUMBER = "SET_SIDEBAR_ACTIVE_NUMBER";
SIDEBAR.FIXED_SIDEBAR_HANDLER = "FIXED_SIDEBAR_HANDLER";
